<template>
  <div>
    <TournamentTeamsModal :association_id="association_id" />
    <TournamentTeamSeedingModal :association_id="association_id" />
    <div>
      <h6 class="mb-2">Pool Play</h6>
      <div class="tip-wrapper mx-0 mt-3 align-items-start"
        v-if="allGamesCompleted && !showSeedColumn && !regeneratingSeeds && isAdmin">
        <span>Let the Brackets Begin!</span>
        <p>All pool games are finished. It’s time to generate seed numbers to set up your bracket matchups.</p>
        <small @click="generateSeeds(false, 0)" class="cursor-pointer position-relative mt-2">
          <div v-if="isLoadingArray[0]" style="width: 24px; height: 24px; position: relative;">
            <img src="../../assets/loader.gif" alt="" style="width: 100%;" />
          </div>
          <div v-else>Generate Seed</div>
        </small>

      </div>
      <div class="tip-wrapper mx-0 mt-3"
        v-else-if="allGamesCompleted && (showSeedColumn || regeneratingSeeds) && isAdmin">
        <span>Looks Good - Start Bracket Play!</span>
        <p>Seeds have been successfully generated from the pool results. You can edit or regenerate them if needed
          before assigning matchups.
          Once you're satisfied, hit Start Bracket Play to lock the seeds and move into bracket play.</p>
        <div class="d-flex align-items-center mt-2" style="gap: 20px;">
          <!-- <button class="btn btn-primary">
            <div v-if="isLoadingArray[0]" style="width: 24px; height: 24px; position: relative;">
              <img src="../../assets/loader.gif" alt="" style="width: 100%;"/>
            </div>
            <div v-else>Start Bracket Play</div>
          </button> -->
          <small @click="generateSeeds(true, 0)" class="cursor-pointer position-relative">
            <div v-if="isLoadingArray[0]" style="width: 24px; height: 24px; position: relative;">
              <img src="../../assets/loader.gif" alt="" style="width: 100%;" />
            </div>
            <div v-else>Regenerate Seed</div>
          </small>
          <small v-if="!isLoadingArray[0]" @click="confirmManualSeedUpdate" class="cursor-pointer">Edit Seed</small>
        </div>
      </div>

      <div class="info-sec">
        <div class="info" v-if="selectedTournamentObj.custom_seed_criteria == '0' || selectedTournamentObj.custom_seed_criteria == null && 
            events.selected_seed_criteria && events.selected_seed_criteria.length">
          <img src="../../assets/Svg/seed-criteria.svg" />
          <div class="info-part">
            <span>Seed</span>
            <span>
              {{
              events.selected_seed_criteria
              .map((c) => c.seed_criteria_name.criteria_name)
              .join(", ")
              }}
            </span>
          </div>
        </div>
        <div class="info d-flex align-items-center" v-if="
          selectedTournamentObj.custom_seed_criteria == '1' && 
              selectedTournamentObj.selected_seed_criteria && 
              selectedTournamentObj.selected_seed_criteria.length
          ">
          <img src="../../assets/Svg/seed-criteria.svg" />
          <div class="info-part d-flex align-items-center" style="gap: 5px;">
            <span>Seed</span>
            <div class="head">
              <p>Custom</p>
            </div>
            <p>
              {{
              selectedTournamentObj.selected_seed_criteria
              .map((c) => c.seeding_criteria?.criteria_name)
              .join(", ")
              }}
            </p>
          </div>
        </div>
        <!-- CUSTOM FORMAT -->
        <div class="info d-flex align-items-center"
          v-if="selectedTournamentObj && selectedTournamentObj.custom_format === '1'">
          <img src="../../assets/Svg/event-format.svg" />
          <div class="info-part d-flex align-items-center" style="gap: 5px;">
            <span>Format</span>
            <div class="head">
              <p>Custom</p>
            </div>
            <p>
              {{ selectedTournamentObj.pool_game_guarantee }} games round robin to seed
              {{ selectedTournamentObj.tournamentName }}
              {{ selectedTournamentObj.bracket_format_info?.bracket_name }} bracket.
            </p>
          </div>
        </div>

        <!-- STANDARD EVENT FORMAT -->
        <div class="info"
          v-else-if="events.game_guarantee && events.division_type && selectedTournamentObj && selectedTournamentObj.custom_format === '0' || selectedTournamentObj.custom_seed_criteria == null">
          <img src="../../assets/Svg/event-format.svg" />
          <div class="info-part">
            <span>Format</span>
            <span>
              {{ events.game_guarantee }} games round robin to seed
              {{ events.eventName }}
              {{ events?.bracket_format?.bracket_name }} bracket.
            </span>
          </div>
        </div>

        <!-- team distribution -->
        <div class="info d-flex">
          <img src="../../assets/Svg/team/team-teammates.svg" />
          <div class="info-part d-flex" style="gap: 5px;">
            <span>Team Distribution</span>
            <div v-if="showTeamLoader === 0 && teamDistributionSummary">
              <p class="total-games-count">
                Teams {{ teamDistributionSummary.totalTeams }},
                Games {{ teamDistributionSummary.totalGames }}
              </p>

              <ul class="total-games-count mb-2">
                <li v-for="item in teamDistributionSummary.distributionText" :key="item.games">
                  {{ item.text }}
                </li>
              </ul>
            </div>

            <div v-else-if="showTeamLoader === 1" style="min-width: 150px;">
              <content-placeholders :rounded="true">
                <content-placeholders-text :lines="2" />
              </content-placeholders>
            </div>

          </div>
        </div>



      </div>



      <div class="pools-wrapper mt-2" style="display: flex; flex-wrap: wrap; gap: 20px;">
        <div v-for="pool in pools" :key="pool.pool_id" class="pool-container" :style="{
          width: pools.length === 1 ? '100%' : 'calc(50% - 10px)',
          'min-width': '300px'
        }">
          <div class="mb-2 text-center" v-if="pools.length > 1 && pool.teams.length > 0">
            <h6>{{ pool.pool_name }}</h6>
          </div>

          <div class="team-list" v-if="pool.teams && pool.teams.length > 0">
            <div class="d-flex align-items-center" style="gap: 15px;">
              <p v-if="showSeedColumn">Seed</p>
              <p>Win</p>
              <p>Loss</p>
            </div>
            <div v-for="(team, index) in pool.teams" :key="index"
              class="team-item d-flex align-items-center justify-content-between">
              <!-- Left Side (Team Info) -->
              <div class="d-flex align-items-center" style="gap: 15px;">
                <div class="d-flex align-items-center pl-1" style="gap: 35px;">
                  <p class="text-center" v-if="showSeedColumn">
                    {{ team?.seed_count }}
                  </p>
                  <p class="text-center">{{ team?.win_count }}</p>
                  <p class="text-center">{{ team?.loss_count }}</p>
                </div>
                <div class="d-flex align-items-center">
                  <div class="user-img">
                    <div class="users-notification" v-if="imgLoader == 1">
                      <img src="../../assets/loader.gif" alt="" />
                    </div>
                    <img @load="onImageLoad" v-if="team?.team?.team_avatar" :src="url + team?.team?.team_avatar" alt=""
                      class="team-avatar" />
                    <img @load="onImageLoad" v-else alt="" :src="team_image" class="team-avatar" />
                  </div>
                  <div class="group-table-name pl-2">
                    <p>#{{ team.team_sr_no }}: {{ team?.team?.team_name }}</p>
                    <span class="team-rating">{{ team.age_group?.name }} -
                      {{ team.ratings?.rate }}</span>
                  </div>
                </div>
              </div>

              <!-- Right Side (Location) -->
              <div class="team-location text-right">
                <p>
                  <img src="../../assets/Svg/location.svg" alt="location" class="pr-1" />
                  {{ team?.team?.city }}, {{ team?.team?.state }}
                </p>
              </div>
            </div>

            <!-- Placeholder Loader -->
            <content-placeholders :rounded="true" v-if="showLoader1 == 1">
              <content-placeholders-heading :img="false" />
            </content-placeholders>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pools.length" v-observe-visibility="handleScrolledToButtom"></div>
    <div class="no-event-wrap h-100 mt-3" v-if="(!pools || pools.length === 0) && showLoader === 0">
      <img src="../../assets/Svg/no-data.svg" alt />
      <p class="header">No division teams found.</p>
      <p class="info">
        There are no division teams to display.
      </p>
    </div>
    <div class="products-list-shim p-0 pt-3" v-if="showLoader == 1">
      <content-placeholders :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
      <content-placeholders class="mt-3" :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
    </div>
  </div>
</template>

<script>
import TournamentTeamsModal from "./Modals/TournamentTeamsModal.vue";
import TournamentTeamSeedingModal from "./Modals/TournamentTeamSeedingModal.vue";
import axios from "axios";

export default {
  name: "TournamentTeams",
  components: {
    TournamentTeamsModal,
    TournamentTeamSeedingModal,
  },
  props: {
    tournamentData: {
      typeof: Object,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: [Number, String],
    },
    association_id: {
      type: [Number, String],
    },
    events: {
      type: Object,
    },
    selectedTournamentObj: {
      type: Object
    }
  },
  data() {
    return {
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      // teamData: [],
      pools: [],
      showLoader1: 1,
      showLoader: 1,
      page: 1,
      teamLastPage: 1,
      tournament_guid: "",
      team_image: require("../../assets/Svg/people.svg"),
      allGamesCompleted: false,
      isDisabled: true,
      isLoadingArray: [],
      regeneratingSeeds: false,
      teamDistributionSummary: [],
      showTeamLoader: 1,

    };
  },
  computed: {
    isAdmin() {
      return this.currentIsAdmin === 1 || this.currentIsAdmin === '1';
    },
    showSeedColumn() {
      // Check if there are any pools with teams
      if (this.pools.length === 0) return false;

      // Check if all teams across all pools have a seed_count greater than 0
      return this.pools.every(
        (pool) =>
          pool.teams &&
          pool.teams.length > 0 &&
          pool.teams.every((team) => Number(team.seed_count) > 0)
      );
    },

  },
  methods: {
    async generateSeeds(isRegeneration = false, index) {
      if (isRegeneration && this.showSeedColumn) {
        try {
          await this.$confirm(
            "About to regenerate the seed. This will overwrite the existing seeds with new ones based on the current pool play results. Don't worry—you can still tweak them afterward if needed. Continue?",
            "Regenerate Seed?",
            {
              confirmButtonText: "Regenerate Seed",
              cancelButtonText: "Cancel",
              type: "warning"
            }
          );
        } catch {
          return;
        }
      }

      this.regeneratingSeeds = true;
      this.showLoader = 1;
      this.isDisabled = false;
      this.$set(this.isLoadingArray, index, true);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/generateTeamSeed`,
          { tournament_guid: this.tournament_guid }
        );

        const { statusCode, message } = response.data;

        if (statusCode === 200) {
          this.pools = [];
          this.page = 1;
          await this.getTournamentTeams();
        } else {
          this.$alert(message || "Something went wrong", "Error");
          if (statusCode === 404) {
            this.$router.push({ name: "Teams" });
          }
        }
      } catch (error) {
        this.$alert("Failed to generate seeds", "Error");
      } finally {
        this.showLoader = 0;
        this.isDisabled = true;
        this.$set(this.isLoadingArray, index, false);
        this.regeneratingSeeds = false;
      }
    },
    handleAllGamesCompleted(allGamesCompleted) {
      this.allGamesCompleted = allGamesCompleted;
    },
    onImageLoad() {
      this.imgLoader = 0;
    },
    handleScrolledToButtom(isVisible) {
      if (this.page >= this.teamLastPage) {
        return;
      }
      if (isVisible) {
        this.page++;
        this.getTournamentTeams();
      }
    },
    callModal() {
      this.$root.$emit("openTournamentTeamsModal", this.tournamentData);
    },
    confirmManualSeedUpdate() {
      const selectedTournament = this.tournamentData.find(
        (t) => t.guid === this.tournament_guid
      );

      console.log("Selected Tournament:", selectedTournament);

      // Directly open modal — no confirmation
      this.callTeamSeededModal(selectedTournament);
    },
    callTeamSeededModal(selectedTournament) {
      this.$root.$emit("openManageTourTeamsSeedarsModal", selectedTournament);
    },
    async getTeamsDistribution() {
      this.showTeamLoader = 1;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getTeamDistribution`,
          {
            params: {
              tournament_guid: this.tournament_guid || this.tournamentData[0]?.guid,
              association_id: this.association_id, // if needed by backend
            }
          }
        );
        if (response.data.statusCode === 200) {
          this.teamDistributionSummary = response.data.data; // directly assign full object
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        console.error("Error fetching team distribution:", error);
      } finally {
        this.showTeamLoader = 0;
      }
    },
    async getTournamentTeams() {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentPoolTeams`,
          {
            tournament_guid:
              this.tournament_guid || this.tournamentData[0]?.guid,
            page: this.page,
            association_id: this.association_id,
          }
        );

        if (response.data.statusCode === 200) {
          const newPools = response.data.data;

          // Sort teams within each pool by team_sr_no
          newPools.forEach((pool) => {
            if (pool.teams) {
              pool.teams.sort((a, b) => a.team_sr_no - b.team_sr_no);
            }
          });

          // If it's the first page, replace the data, otherwise append
          if (this.page === 1) {
            this.pools = newPools;
          } else {
            // Merge with existing pools
            newPools.forEach((newPool) => {
              const existingPool = this.pools.find(
                (p) => p.pool_id === newPool.pool_id
              );
              if (existingPool) {
                existingPool.teams = [...existingPool.teams, ...newPool.teams];
              } else {
                this.pools.push(newPool);
              }
            });
          }

          this.teamLastPage = response.data.data.last_page || 1;
          this.showLoader1 = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader1 = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        console.error("Error fetching tournament teams:", error);
      } finally {
        this.showLoader = 0;
      }
    },
    
  },
  mounted() {
    console.log("eventData", this.events);
    const storedTournamentID = localStorage.getItem("tournamentID");
    if (storedTournamentID) {
      this.tournament_guid = storedTournamentID;
    }

    this.getTournamentTeams();
    this.getTeamsDistribution();


    this.$root.$on("allGamesCompleted", this.handleAllGamesCompleted);

    this.$root.$on("showTournamentForSwitch", () => {
      this.pools = [];
      this.getTournamentTeams();
      this.getTeamsDistribution();

    });
    this.$root.$on("refreshTeamOnGameDelete", () => {
      this.pools = [];
      this.getTournamentTeams();
      this.getTeamsDistribution();
    });

    this.$root.$on("selectedTournamentTeamEmit", () => {
      this.pools = [];
      this.getTournamentTeams();
      this.getTeamsDistribution();

    });

    this.$root.$on("changeDivision", (tournamentID) => {
    console.log("changeDivision tournamentID", tournamentID);
      this.allGamesCompleted = false;
      this.tournament_guid = tournamentID;
      localStorage.setItem("tournamentID", tournamentID); // Save to localStorage
      this.pools = [];
      this.getTournamentTeams();
      this.getTeamsDistribution();
    });
  },
};
</script>
